// src/components/Contact.js
import React from "react";
import {
  Facebook,
  EmailOutlined,
  CallOutlined,
  Language,
} from "@mui/icons-material";

const Contact = ({ id }) => (
  <section id={id} style={styles.section}>
    <h2 style={styles.heading}>Contáctanos para obtener más información</h2>
    <ul style={styles.list}>
      <li style={styles.listItemTelephone}>
        <CallOutlined style={styles.imgs} />
        3339557276
      </li>
      <li style={styles.listItem}>
        <EmailOutlined style={styles.imgs} />
        taliachavez@play-dei.com
      </li>
      <li style={styles.listItem}>
        <Language style={styles.imgs} />
        www.playdei.com
      </li>
      <li style={styles.listItem}>
        <Facebook style={styles.imgs} />
        <a
          style={styles.link}
          href="https://www.facebook.com/profile.php?id=61563536510072"
        >
          Dale play a la diversidad, equidad e inclusión
        </a>
      </li>
    </ul>
  </section>
);

const styles = {
  section: {
    padding: "20px",
    fontFamily: "Outfit, serif",
    fontSize: "2rem",
    position: "relative",
    fontWeight: "250",
  },
  heading: {
    background: "#15C4C0",
    color: "#fff",
    textAlign: "center",
    padding: "20px",
    fontSize: "2rem",
    position: "absolute",
    top: "0",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100vw",
  },
  list: {
    marginTop: "150px",
    listStyle: "none",
    lineHeight: "1.6",
    paddingLeft: "20px",
  },
  listItem: {
    fontSize: "1.8rem",
    paddingLeft: "70px",
    marginBottom: "10px",
    position: "relative",
  },
  listItemTelephone: {
    fontSize: "1.8rem",
    paddingLeft: "70px",
    marginBottom: "10px",
    fontWeight: "400",
    position: "relative",
  },
  imgs: {
    fontSize: 30,
    color: "##9BACAE",
    position: "absolute",
    top: "8px",
    left: "0",
  },
  link: {
    color: "inherit",
    textDecoration: "none",
    cursor: "pointer",
  },
};

export default Contact;
